import $api from 'http/index';
import { getOptions } from 'helpers/getOptions';
import { laborClassificationsActions } from './laborClassificationsSlice';

const BASE = `${process.env.REACT_APP_BASE_URL}/labor-classifications`;

const extractErrorMessage = (error) => {
  const data = error?.response?.data;
  if (!data) return error?.message || 'Request failed';
  if (Array.isArray(data.message)) return data.message.join('\n');
  return data.message || error.message || 'Request failed';
};

const extractStatus = (error) => error?.response?.status;
const extractBody = (error) => error?.response?.data;

export const bootstrapLaborClassifications = () => async (dispatch) => {
  dispatch(laborClassificationsActions.setLoading(true));
  try {
    const response = await $api.get(BASE, {
      ...getOptions(),
      params: { includeDeleted: true },
    });
    const list = Array.isArray(response.data) ? response.data : response.data?.items || [];
    dispatch(laborClassificationsActions.bootstrapSucceeded(list));
  } catch (error) {
    dispatch(laborClassificationsActions.setError(extractErrorMessage(error)));
    dispatch(laborClassificationsActions.setLoading(false));
  }
};

export const fetchLaborClassificationsForProject = (projectId) => async (dispatch) => {
  if (!projectId) return;
  try {
    const response = await $api.get(BASE, {
      ...getOptions(),
      params: { projectId },
    });
    const list = Array.isArray(response.data) ? response.data : response.data?.items || [];
    dispatch(laborClassificationsActions.projectListMerged({ projectId, list }));
  } catch (error) {
    dispatch(laborClassificationsActions.setError(extractErrorMessage(error)));
    throw error;
  }
};

export const createLaborClassification = (name) => async (dispatch) => {
  try {
    const response = await $api.post(BASE, { name }, getOptions());
    const created = response.data;
    dispatch(laborClassificationsActions.lcCreated(created));
    return created;
  } catch (error) {
    const status = extractStatus(error);
    if (status === 409) {
      const body = extractBody(error);
      const reason = { status: 409, field: body?.field || 'name', value: body?.value || name };
      throw reason;
    }
    throw new Error(extractErrorMessage(error));
  }
};

export const renameLaborClassification = ({ id, name }) => async (dispatch) => {
  try {
    const response = await $api.patch(`${BASE}/${id}`, { name }, getOptions());
    const updated = response.data;
    dispatch(laborClassificationsActions.lcRenamed(updated));
    return updated;
  } catch (error) {
    const status = extractStatus(error);
    if (status === 409) {
      const body = extractBody(error);
      const reason = { status: 409, field: body?.field || 'name', value: body?.value || name };
      throw reason;
    }
    throw new Error(extractErrorMessage(error));
  }
};

export const deleteLaborClassification = (id) => async (dispatch) => {
  try {
    await $api.delete(`${BASE}/${id}`, getOptions());
    dispatch(laborClassificationsActions.lcSoftDeleted(id));
    return { ok: true };
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
};

